/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'see more': {
    width: 16,
    height: 16,
    viewBox: '0 0 60.06 33.95',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M.39 16.41C.85 15.84 12.64.5 30 .5s29.21 15.34 29.67 15.91M40.55 23a10.52 10.52 0 1 0-3.12 7.37"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/see more.js